import {
  takeLatest, takeEvery, put, call, all,
} from 'redux-saga/effects';
import * as actions from '@actions';
import Message from '@rootCommon/services';
import { IdType } from '@rootTypes/common';
import { FhqGeneralSetting, FhqGeneralSettingDto } from '@rootTypes/fhq';
import FhqGeneralSettingsService from '@services/fhq-general-settings';
import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// fetch
function* fetchFhqGeneralSettingsAsync(action: { payload: IdType }) {
  try {
    const fhqGeneralSettings: FhqGeneralSetting = yield call(
      FhqGeneralSettingsService.getListBySiteId,
      action.payload,
    );

    yield put(actions.fetchFhqGeneralSettings.success(fhqGeneralSettings));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchFhqGeneralSettings.failure(error));
  }
}

function* watchFetchFhqGeneralSettings() {
  yield takeLatest(actions.fetchFhqGeneralSettings.request, fetchFhqGeneralSettingsAsync);
}

// update
function* updateFhqGeneralSettingAsync(action: { payload: { id: IdType; data: FhqGeneralSettingDto } }) {
  try {
    const fhqGeneralSetting: FhqGeneralSetting = yield call(
      FhqGeneralSettingsService.update,
      action.payload.id,
      action.payload.data,
    );

    yield put(actions.updateFhqGeneralSettings.success(fhqGeneralSetting));
    Message.success('General settings were successfully updated');
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.updateFhqGeneralSettings.failure(error));
  }
}

function* watchUpdateFhqGeneralSetting() {
  yield takeEvery(actions.updateFhqGeneralSettings.request, updateFhqGeneralSettingAsync);
}

// all
function* watchFhqGeneralSettings(): SagaGenerator {
  yield all([watchFetchFhqGeneralSettings(), watchUpdateFhqGeneralSetting()]);
}

export default watchFhqGeneralSettings;
